import React from 'react';
import { ChevronRight } from 'lucide-react';
export function CallToAction() {
  return <div className="my-10" data-id="element-154">
      <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg" data-id="element-155">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-156">
          Discover how to reverse your own dad-bod transformation using the
          scientifically-proven Metabolic Recomp Protocol
        </h3>
        <div className="flex justify-center mt-6" data-id="element-157">
          <a href="https://physiquebuilding.com/op/book-2/" className="flex items-center justify-center bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg transition duration-300 text-lg" data-id="element-158">
            Learn More
            <ChevronRight className="ml-2 w-5 h-5" data-id="element-159" />
          </a>
        </div>
      </div>
    </div>;
}